import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/hooks';
import { orders } from '../../redux/orders/action';
import { selectOrdersPrintItem } from '../../redux/orders/selector';
import { useSelector } from 'react-redux';
import PageLoader from '../../components/PageLoader';
import { format } from '../services/date.service';


const InvoiceBill = ({

}: any) => {
	const dispatch = useAppDispatch()
	const parmas: any = useParams()
	const [isLoading, setIsLoading] = useState<boolean>(true)
	const orderInvoiceData = useSelector(selectOrdersPrintItem)
	const [isQuery, setIsQuery] = useState<boolean>(false)
	const [
		orderInvoice,
		setOrderInvoice
	] = useState<any>({})

	const invoiceData: any = {
		companyName: orderInvoice?.BusinessDetail?.Name,
		companyAddress: `${orderInvoice?.BusinessDetail?.Address?.building},${orderInvoice?.BusinessDetail?.Address?.locality},${orderInvoice?.BusinessDetail?.Address?.city},${orderInvoice?.BusinessDetail?.Address?.state}-${orderInvoice?.BusinessDetail?.Address?.area_code},${orderInvoice?.BusinessDetail?.Address?.country}`,
		contactInfo: `Phone: ${orderInvoice?.BusinessDetail?.PhoneNumber} | Email: ${orderInvoice?.BusinessDetail?.EmailId}`,
		invoiceNumber: orderInvoice?.BillingDetail?.InvoiceNumber,
		date: format(orderInvoice?.BillingDetail?.InvoiceDate),
		customerName: orderInvoice?.CustomerDetail?.Name,
		customerAddress: `${orderInvoice?.CustomerDetail?.Address?.building},${orderInvoice?.CustomerDetail?.Address?.locality}`,
		cityStateZip: `${orderInvoice?.CustomerDetail?.Address?.city},${orderInvoice?.CustomerDetail?.Address?.state}-${orderInvoice?.CustomerDetail?.Address?.area_code},${orderInvoice?.CustomerDetail?.Address?.country}`,
		items: orderInvoice?.OrderDetail?.order_items,
		tax: 0,
		paymentInstructions: `Account: ${orderInvoice?.PaymentDetail?.BankAccountNumber} | IFSC_Code:${orderInvoice?.PaymentDetail?.IFSC_Code}`
	};
	// const subtotal = invoiceData?.items.reduce((sum: any, item: any) => sum + item.quantity * item.DeliveryCharge, 0);
	// const total = subtotal + invoiceData?.tax;

	const fetchOrderInvoiceById = async () => {
		await dispatch(orders.resetAction({ actionType: 'print' }))
		await dispatch(orders.print({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/invoice`, entity: 'orders', jsonData: {


				Records: [
					{
						context: {},
						Message: {
							InvoiceNumber: parmas?.id
						}
					}
				]

			}
		}))
		await setIsQuery(true)


	}
	const fetchDataOrder = async () => {
		await setOrderInvoice(orderInvoiceData?.result?.items?.Message)
		await window.print()
	}

	useEffect(() => {
		if (!isQuery) {
			fetchOrderInvoiceById()
		} else if (isQuery && orderInvoiceData?.isSuccess) {
			fetchDataOrder()
		}

	}, [isQuery]);
	return (
		<div className="p-6 max-w-4xl mx-auto bg-white border border-gray-200 shadow-md rounded-lg">
			<header className="mb-6 text-center">
				<h1 className="text-2xl font-bold mb-2">{invoiceData?.companyName}</h1>
				<p className="text-gray-600">{invoiceData?.companyAddress}</p>
				<p className="text-gray-600">{invoiceData?.contactInfo}</p>
			</header>

			<section className="mb-6">
				<div className="flex justify-between">
					<div>
						<p className="font-bold">Invoice Number:</p>
						<p>{invoiceData?.invoiceNumber}</p>
					</div>
					<div>
						<p className="font-bold">Date:</p>
						<p>{invoiceData?.date}</p>
					</div>
				</div>
			</section>

			<section className="mb-6">
				<h2 className="text-lg font-bold">Bill To:</h2>
				<p>{invoiceData?.customerName}</p>
				<p>{invoiceData?.customerAddress}</p>
				<p>{invoiceData?.cityStateZip}</p>
			</section>

			<section className="mb-6">
				<table className="w-full border-collapse border border-gray-300">
					<thead>
						<tr className="bg-gray-100">
							<th className="border border-gray-300 px-4 py-2 text-left">Description</th>
							<th className="border border-gray-300 px-4 py-2 text-right">Quantity</th>
							<th className="border border-gray-300 px-4 py-2 text-right">Weight</th>
							{/* <th className="border border-gray-300 px-4 py-2 text-right">Amount</th> */}
						</tr>
					</thead>
					<tbody>
						{invoiceData?.items?.map((item: any, index: any) => (
							<tr key={index}>
								<td className="border border-gray-300 px-4 py-2">{item.ItemName}</td>
								<td className="border border-gray-300 px-4 py-2 text-right">{item.quantity}</td>
								<td className="border border-gray-300 px-4 py-2 text-right">{item.weight}</td>
								{/* <td className="border border-gray-300 px-4 py-2 text-right">₹{(item.quantity * item.rate).toFixed(2)}</td> */}
							</tr>
						))}
					</tbody>
				</table>
			</section>

			<section className="mb-6 text-right">
				<p className="text-lg font-bold">Subtotal: ₹{orderInvoice?.OrderDetail?.DeliveryCharge.toFixed(2)}</p>
				<p className="text-lg font-bold">Tax: ₹{invoiceData?.tax.toFixed(2)}</p>
				<p className="text-xl font-bold">Total Amount: ₹{orderInvoice?.OrderDetail?.TotalAmount.toFixed(2)}</p>
			</section>

			<footer className="mt-6 border-t border-gray-300 pt-4">
				<h2 className="text-lg font-bold mb-2">Payment Instructions</h2>
				<p>{invoiceData?.paymentInstructions}</p>
			</footer>
		</div>



	);
};

const Invoice = () => {


	return <InvoiceBill />;
}
export default Invoice;
